import { ChangeDetectorRef, Component, ErrorHandler, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy, Injector, inject, signal } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { ActivatedRoute, Router } from '@angular/router'

import {
  LaskuComponentDataResolve,
  LaskuComponentExistingData,
  LaskuKatseleComponentData,
  LaskuKatseleComponentExistingData,
  LaskuSelaaKatseleComponentDataResolve,
} from '../../_angular/_resolvers/lasku.resolve'
import { AsiakasService, AsiakkaanAvainTiedot } from '../../_angular/service/asiakas/asiakas.service'
import { KirjanpitajaService } from '../../_angular/service/kirjanpitaja/kirjanpitaja.service'
import { LaskuService } from '../../_angular/service/lasku/lasku.service'
import { LEMONATOR_CF_API, LemonHttpService } from '../../_angular/service/lemon-http.service'

import { Asiakas } from '../../_jaettu-lemonator/model/asiakas'

import {
  EmailLahetysStatus,
  EmailLahetysStatusKoodi,
  KorjattavanEmailOsoitteenTiedot,
  Lasku,
  LaskuBase,
  LaskuReskontra,
  LaskuSahkoinenLahetysStatusKoodi,
  LaskuToimintaloki,
  Laskuasetukset,
  LaskunLahetysdata,
  LaskunLahetystapa,
  LaskunLiitetiedosto,
  LaskunTila,
  LaskunToimintalokiSahkoinenParametrit,
  LaskunToimintalokiSpostiParametrit,
  LaskunToimintalokiTilastoParametrit,
  LaskunToimintalokiTyyppi,
  LaskunTyypit,
  LaskunVersiot,
  LaskunumeroTyyppi,
  PeppolValidaatioTulos,
  SummatekstinVari,
  ViestiTyyppi,
} from '@lemon/core-firebase/model/lasku'

import { LaskuPdfEsikatselutiedot } from '../../_jaettu-angular/laskut/esikatselu/pdf.perinteinen.component'
import { LadataanService } from '../../_jaettu-angular/service/ladataan.service'
import { LemonTranslationService } from '../../_jaettu-angular/service/lemon-translation.service'
import { TimestampService } from '../../_jaettu-angular/service/timestamp-service'
import { LaskuReskontraTiedotDialog } from '../dialogit/lasku.reskontra-tiedot.dialog'

import { BehaviorSubject, Observable, Subject, combineLatest, firstValueFrom, from, of } from 'rxjs'
import { debounceTime, first, map, startWith, switchMap, takeUntil, tap } from 'rxjs/operators'

import { LaskuKokoVirheDialog } from '../dialogit/lasku.koko-virhe.dialog'
import { LaskuLataaDialog, LaskuLataaDialogData } from '../dialogit/lasku.lataa.dialog'

import { LaskuSharedService, ReskontraService } from '@lemon/core-firebase/service/lasku/lasku-shared.service'
import { LaskuUriService } from '@lemon/core-firebase/service/lasku/lasku-uri.service'
import { SahkoisenLaskunValittajaService, Verkkolaskuoperaattori } from '@lemon/core-firebase/service/lasku/sahkoisen-laskun-valittaja.service'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { DateService } from '@lemon/core/service/date.service'

import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'
import { applyEach, email, FieldTree, form, minLength, required } from '@angular/forms/signals'
import { MatSnackBar } from '@angular/material/snack-bar'
import { LaskuSpostiService } from '@lemon/core-firebase/service/lasku/lasku-sposti.service'
import { LaskuKopioija } from '@lemon/core-firebase/service/lasku/lasku.kopioija'
import { TuettuKieli } from '@lemon/core/model/common'
import { StringService } from '@lemon/core/service/string.service'
import { DebugService } from 'app/_angular/service/debug.service'
import { FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { KirjautunutKayttajaService } from 'app/_angular/service/kirjautunut-kayttaja.service'
import { arvonMuutokset, asetaArvo } from 'app/_jaettu-angular/_lomakkeet/arvon-muutokset'
import { validoiReaktiivisesti } from 'app/_jaettu-angular/_lomakkeet/reaktiivinen-validaattori'
import { lemonShare } from 'app/_jaettu-angular/_rxjs/lemon-share.operator'
import { AlvService } from 'app/_jaettu-angular/service/alv.service'
import { FileSaverService } from 'app/_jaettu-angular/service/file-saver'
import { FormValidationService } from 'app/_jaettu-angular/service/form-validation.service'
import { LaskuKaynnistaOperaatioRequest, LaskuKaynnistaOperaatioResponse } from 'app/_jaettu-lemonator/model/lasku'
import { KirjanpitoUriService } from 'app/_jaettu-lemonator/service/kirjanpito-uri.service'
import { EnvironmentType } from 'app/app.environment'
import { environment } from 'environments/environment'
import { AreYouSureDialog, AreYouSureDialogData } from '../../_jaettu-angular/_components/are-you-sure.dialog'
import { VasenValikkoService } from '../../_jaettu-angular/service/vasen-valikko.service'
import { LaskuMerkitseOsittainMaksetuksiLemonatorDialog, LaskuMerkitseOsittainMaksetuksiLemonatorDialogData } from '../dialogit/lasku-merkitse-osittain-maksetuksi-lemonator.dialog'
import { LaskunLahetystiedot } from '../laheta-lemonator.component'

interface KasiteltyLokitieto {
  parametrit: any
  loki: LaskuToimintaloki
  tekija: string
  viesti: string
}

interface SahkoinenLomake {
  ytunnus: string
  osoite: string
  valittaja: string | null
}

interface KorjattavaEmailLahetysStatus extends EmailLahetysStatus {
  vanhaEmail: string
}

@Component({
  templateUrl: './lasku-selaa.katsele.component.html',
  styleUrls: ['../lasku.katsele.component.css'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class LaskuSelaaKatseleComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject<void>()
  private readonly _injector = inject(Injector)

  reskontraObservable: Observable<LaskuReskontra[]>
  reskontraLokiObservable: Observable<{ data: LaskuReskontra; teksti: string }[]>
  reskontraSummaObservable: Observable<number>
  reskontraaLadataanObservable: Observable<boolean>
  lokitiedotObservable: Observable<KasiteltyLokitieto[]>
  lokitietojaLadataanObservable: Observable<boolean>
  laskuUriObservable: Observable<string>
  laskuEncodedUriObservable: Observable<string>
  kirjattavalaskuUriObservable: Observable<string>
  kirjattavalaskuEncodedUriObservable: Observable<string>
  hakemistoLaskuUriObservable: Observable<string>
  hakemistoLaskuEncodedUriObservable: Observable<string>
  toistuvaLaskuUriObservable: Observable<string>
  toistuvaLaskuEncodedUriObservable: Observable<string>
  kirjanpitajaOnDevaajaObservable: Observable<boolean> = this._kirjautunutKayttajaService.kirjanpitajaOnDevaajaObservable
  kirjanpitajaOnDevaajaTaiTukiObservable: Observable<boolean> = this._kirjautunutKayttajaService.kirjanpitajaOnDevaajaTaiTukiObservable
  kirjanpitajaOnHallintoTaiLuottoObservable: Observable<boolean>
  korjattavatEmailOsoitteet: KorjattavanEmailOsoitteenTiedot[] = []
  private peppolValidationSubject: BehaviorSubject<PeppolValidaatioTulos | null> = new BehaviorSubject(null)
  peppolValidationObservable: Observable<PeppolValidaatioTulos | null> = this.peppolValidationSubject.asObservable()

  verkkolaskuoperaattorit: Verkkolaskuoperaattori[]

  lokit: LaskuToimintaloki[] = []
  data: LaskuKatseleComponentData = null
  juurilasku: Lasku = null
  kasiteltava: LaskuBase = null
  asiakas: Asiakas = null
  asetukset: Laskuasetukset = null
  ladaataanToimintalokia = true
  esikatselutiedot: LaskuPdfEsikatselutiedot = null
  otsikko: string = null
  namename = 'asfrtegoq' + Math.random()
  versiot: LaskunVersiot[] = []
  paluuUrl: string = ''

  sahkoinenLomake: FieldTree<SahkoinenLomake>
  vastaanottajienLomake = form(signal<string[]>([]), polku => {
    applyEach(polku, osoite => {
      required(osoite)
      email(osoite)
    })
  })

  aktiivinenValilehti: BehaviorSubject<number> = new BehaviorSubject(0)
  lahetysdata: BehaviorSubject<LaskunLahetysdata> = new BehaviorSubject(null)

  private _buttonPushInflight: boolean = false

  annaOsoitteenValidointiFunktio(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value) {
        const ctrlValue = this._stringService.removeAllWhiteSpaces(control.value)
        const valittajat = this.verkkolaskuoperaattorit
        for (const valittaja of valittajat) {
          if (this._stringService.removeAllWhiteSpaces(valittaja.tunnus) === ctrlValue) {
            return { valittaja: true }
          }
        }
      }
      return null
    }
  }

  constructor(
    // private router: Router,
    private _route: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef,
    private _laskuService: LaskuService,
    private _errorHandler: ErrorHandler,
    public _laskuSharedService: LaskuSharedService,
    private _kirjanpitoUriService: KirjanpitoUriService,
    private _dialog: MatDialog,
    private _laskuComponentDataResolve: LaskuComponentDataResolve,
    private _dateService: DateService,
    private _httpService: LemonHttpService,
    private _lemonTranslationService: LemonTranslationService,
    private _currencyService: CurrencyService,
    private _timestampService: TimestampService,
    private _ladataanService: LadataanService,
    private _reskontraService: ReskontraService,
    private _asiakasService: AsiakasService,
    private _kirjanpitajaService: KirjanpitajaService,
    private _laskuUriService: LaskuUriService,
    private _sahkoisenLaskunValittajaService: SahkoisenLaskunValittajaService,
    private _stringService: StringService,
    private _validationService: FormValidationService,
    private _debugService: DebugService,
    private _kirjautunutKayttajaService: KirjautunutKayttajaService,
    private _fileSaverService: FileSaverService,
    private _laskuKopioija: LaskuKopioija,
    private _alvService: AlvService,
    private _laskuSpostiService: LaskuSpostiService,
    private _router: Router,
    private _vasenValikkoService: VasenValikkoService,
    private _laskuSelaaKatseleComponentDataResolve: LaskuSelaaKatseleComponentDataResolve,
    private _firebaseLemonator: FirebaseLemonator,
    private _snackbar: MatSnackBar,
  ) {}

  // private _filter(value): Verkkolaskuoperaattori[] {
  //   if (!value) {
  //     return []
  //   }
  //   const tarkasteltavaArvo = (value + '').trim().toLowerCase()
  //   if (tarkasteltavaArvo === '') {
  //     return []
  //   }
  //   return this.sahkoisenLaskunValittajaService.annaKaikkiValittajat().filter(operaattori => operaattori.nimi.toLowerCase().includes(tarkasteltavaArvo) || operaattori.tunnus.toLowerCase().includes(tarkasteltavaArvo))
  // }

  ngOnInit() {
    this.laskuUriObservable = combineLatest([this._asiakasService.nykyinenAsiakasAvainObservable, this._route.data]).pipe(
      map(([asiakas, data]: [Asiakas, { data: LaskuKatseleComponentData }]) => {
        if (asiakas && data?.data?.juurilasku) {
          return this._laskuUriService.getCustomerLaskuUri(asiakas.avain, data.data.juurilasku.avain)
        }
        return ''
      }),
    )

    this.laskuEncodedUriObservable = combineLatest([this._asiakasService.nykyinenAsiakasAvainObservable, this._route.data]).pipe(
      map(([asiakas, data]: [Asiakas, { data: LaskuKatseleComponentData }]) => {
        if (asiakas && data?.data?.juurilasku) {
          const uri = this._laskuUriService.getCustomerLaskuUri(asiakas.avain, data.data.juurilasku.avain)
          return this._debugService.createFirestoreLinkLemonaid(uri)
        }
        return ''
      }),
    )

    this.kirjattavalaskuUriObservable = combineLatest([this._asiakasService.nykyinenAsiakasAvainObservable, this._route.data]).pipe(
      map(([asiakas, data]: [Asiakas, { data: LaskuKatseleComponentData }]) => {
        if (asiakas && data?.data?.juurilasku) {
          return this._kirjanpitoUriService.annaKirjattavanLaskunUriLaskulla(asiakas, data.data.juurilasku)
        }
        return ''
      }),
    )
    this.kirjattavalaskuEncodedUriObservable = combineLatest([this._asiakasService.nykyinenAsiakasAvainObservable, this._route.data]).pipe(
      map(([asiakas, data]: [Asiakas, { data: LaskuKatseleComponentData }]) => {
        if (asiakas && data?.data?.juurilasku) {
          const kirjattavaLaskuUri = this._kirjanpitoUriService.annaKirjattavanLaskunUriLaskulla(asiakas, data.data.juurilasku)
          return this._debugService.createFirestoreLink(kirjattavaLaskuUri)
        }
        return ''
      }),
    )

    this.hakemistoLaskuUriObservable = combineLatest([this._asiakasService.nykyinenAsiakasAvainObservable, this._route.data]).pipe(
      map(([asiakas, data]: [Asiakas, { data: LaskuKatseleComponentData }]) => {
        if (asiakas && data?.data?.juurilasku) {
          return 'hakemisto-lasku/' + data.data.kasiteltava.avain
        }
        return ''
      }),
    )
    this.hakemistoLaskuEncodedUriObservable = combineLatest([this._asiakasService.nykyinenAsiakasAvainObservable, this._route.data]).pipe(
      map(([asiakas, data]: [Asiakas, { data: LaskuKatseleComponentData }]) => {
        if (asiakas && data?.data?.juurilasku) {
          const hakemistoLaskuUri = 'hakemisto-lasku/' + data.data.kasiteltava.avain
          return this._debugService.createFirestoreLinkLemonaid(hakemistoLaskuUri)
        }
        return ''
      }),
    )

    this.toistuvaLaskuUriObservable = combineLatest([this._asiakasService.nykyinenAsiakasAvainObservable, this._route.data]).pipe(
      map(([asiakas, data]: [Asiakas, { data: LaskuKatseleComponentData }]) => {
        if (asiakas && data?.data?.kasiteltava) {
          return 'customers/' + asiakas.avain + '/customer-laskut-toistuvat/' + data.data.kasiteltava.avain
        }
        return ''
      }),
    )

    this.toistuvaLaskuEncodedUriObservable = combineLatest([this._asiakasService.nykyinenAsiakasAvainObservable, this._route.data]).pipe(
      map(([asiakas, data]: [Asiakas, { data: LaskuKatseleComponentData }]) => {
        if (asiakas && data?.data?.kasiteltava) {
          const toistuvaLaskuUri = 'customers/' + asiakas.avain + '/customer-laskut-toistuvat/' + data.data.kasiteltava.avain
          return this._debugService.createFirestoreLinkLemonaid(toistuvaLaskuUri)
        }
        return ''
      }),
    )

    this.sahkoinenLomake = form(
      signal<SahkoinenLomake>({ ytunnus: '', osoite: '', valittaja: '' }),
      polku => {
        required(polku.osoite)
        validoiReaktiivisesti(polku.osoite, this.annaOsoitteenValidointiFunktio())
        minLength(polku.osoite, 9, { when: ({ valueOf }) => valueOf(polku.valittaja)?.trim() === 'PEPPOL' })
        required(polku.valittaja)
      },
      { injector: this._injector },
    )

    this.verkkolaskuoperaattorit = this._sahkoisenLaskunValittajaService.annaKaikkiValittajat()

    // this.sahkoinenForm.get('ytunnus').valueChanges.subscribe(value => {
    //   this.sahkoinen.ytunnus = value
    // })
    const muutokset = <T>(kentta: FieldTree<T>) => arvonMuutokset(kentta, { injector: this._injector })
    muutokset(this.sahkoinenLomake.osoite)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(value => {
        this.kasiteltava.sahkoinen.osoite.sahkoinenOsoite = value?.trim()
      })
    muutokset(this.sahkoinenLomake.valittaja)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(value => {
        this.kasiteltava.sahkoinen.osoite.sahkoinenValittaja = value?.trim()
      })
    muutokset(this.vastaanottajienLomake)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(osoitteet => {
        osoitteet.forEach((osoite, i) => {
          const vastaanottaja = this.kasiteltava?.email?.vastaanottajat?.[i]
          if (vastaanottaja && (vastaanottaja.email ?? '') !== osoite) {
            vastaanottaja.email = osoite
          }
        })
      })

    combineLatest([muutokset(this.sahkoinenLomake.osoite), muutokset(this.sahkoinenLomake.valittaja)])
      .pipe(
        debounceTime(500),
        switchMap(([osoite, valittaja]) => {
          if (valittaja !== 'PEPPOL') {
            return of(null)
          }

          if (!osoite || osoite.trim().length < 9) {
            return of(null)
          }

          return from(this._laskuService.validoiPeppolOsoite(osoite, this._lemonTranslationService.nykyinenKieli)).pipe(
            startWith({ error: false, message: this._lemonTranslationService.lokalisoi('lasku.peppol-validaatio.tarkistetaan', this._lemonTranslationService.nykyinenKieli) }),
          )
        }),
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe(value => {
        this.peppolValidationSubject.next(value)
      })

    this._route.data
      .pipe(
        tap(data => {
          this.juurilasku = data.data.juurilasku
          this.kasiteltava = data.data.kasiteltava
          asetaArvo(
            this.vastaanottajienLomake,
            (this.kasiteltava.email?.vastaanottajat ?? []).map(vastaanottaja => vastaanottaja.email ?? ''),
            { ilmoita: false },
          )
          this.asetukset = data.data.asetukset

          if (data.data.tulosta) {
            setTimeout(() => {
              this.lataaLasku()
              this._changeDetectorRef.markForCheck()
            }, 25)
          }
        }),
        switchMap(routeData => this._asiakasService.nykyinenAsiakasObservable.pipe(map(asiakas => [routeData, asiakas] as [{ data: LaskuKatseleComponentData }, Asiakas]))),
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe(([data, asiakas]) => {
        this.asiakas = asiakas

        this.juurilasku = data.data.juurilasku
        this.kasiteltava = data.data.kasiteltava
        this.asetukset = data.data.asetukset
        this.data = data.data
        if (this.kasiteltava.email && this.kasiteltava.email.vastaanottajat) {
          for (const vastaanottaja of this.kasiteltava.email.vastaanottajat) {
            const korjattava = vastaanottaja as KorjattavaEmailLahetysStatus
            korjattava.vanhaEmail = korjattava.email
          }
        }
        if (this.kasiteltava.sahkoinen && this.kasiteltava.sahkoinen.osoite) {
          const valittajaTunnus = this.kasiteltava.sahkoinen.osoite.sahkoinenValittaja
          asetaArvo(this.sahkoinenLomake.osoite, this.kasiteltava.sahkoinen.osoite.sahkoinenOsoite ?? '')
          // This form field used to be a free-text input, so an extra comparison is needed here to catch invalid operator ID-s in legacy data.
          const haettuValittaja: Verkkolaskuoperaattori = this._sahkoisenLaskunValittajaService.annaValittaja(valittajaTunnus)
          const confirmedValittajaTunnus = haettuValittaja?.tunnus ?? null
          asetaArvo(this.sahkoinenLomake.valittaja, confirmedValittajaTunnus)
        }
        this.esikatselutiedot = {
          asetukset: this.asetukset,
          juurilasku: this.juurilasku,
          kasiteltava: this.kasiteltava,
        }
        if (this.naytaKorvatunOtsake()) {
          this.otsikko = this.annaKorvatunOtsake()
        }
        if (this.naytaTavallinenOtsake()) {
          this.otsikko = 'Lasku ' + this._laskuSharedService.annaMuotoiltuLaskunumero(this.juurilasku, this.kasiteltava)
        }

        const paluu = this._route.snapshot.queryParams['paluu']
        if (paluu === 'toistuvat') {
          this.paluuUrl = '/asiakkaat/' + asiakas.avain + '/laskut/toistuvat'
        } else {
          this.paluuUrl = '/asiakkaat/' + asiakas.avain + '/laskut/selaa'
        }
        this._changeDetectorRef.markForCheck()
      })

    const kipienJaKayttajienNimetMapObservable = combineLatest([this._asiakasService.nykyisenAsiakkaanKayttajatObservable, this._kirjanpitajaService.kirjanpitajienNimitiedotObservable]).pipe(
      map(([kayttajat, kipit]) => {
        const kayttajienNimetMap: Map<string, string> = new Map()
        for (const kayttaja of kayttajat) {
          kayttajienNimetMap.set(kayttaja.avain, kayttaja.etunimi + ' ' + kayttaja.sukunimi)
        }
        for (const kipi of kipit) {
          kayttajienNimetMap.set(kipi.avain, kipi.etunimi + ' ' + kipi.sukunimi)
          kayttajienNimetMap.set(kipi.lemonaidUid, kipi.etunimi + ' ' + kipi.sukunimi)
        }
        return kayttajienNimetMap
      }),
    )

    // Lataa lokitiedot
    const lokitiedotFirestorestaObservable = combineLatest([this._route.data, this._asiakasService.nykyinenAsiakasAvainObservable]).pipe(
      switchMap(([routeData, asiakas]: [{ data: LaskuKatseleComponentData }, AsiakkaanAvainTiedot]) => {
        if (routeData && routeData.data && routeData.data.juurilasku && routeData.data.juurilasku.avain) {
          return this._laskuService.getLaskuToimintalokiObservableAsiakkaalle(asiakas.avain, routeData.data.juurilasku.avain)
        } else {
          return of<LaskuToimintaloki[]>([])
        }
      }),
    )

    this.lokitiedotObservable = combineLatest([lokitiedotFirestorestaObservable, kipienJaKayttajienNimetMapObservable]).pipe(
      takeUntil(this.ngUnsubscribe),
      map(([kaikkiLokit, kipienJaKayttajienNimetMap]) => {
        const tyyppi = this.kasiteltava.nrotyyppi
        const lokit: KasiteltyLokitieto[] = []

        if (tyyppi === LaskunumeroTyyppi.HYVITYS || tyyppi === LaskunumeroTyyppi.MUISTUTUS) {
          for (const loki of kaikkiLokit) {
            if (loki.lasku_uid === this.kasiteltava.avain) {
              const parametrit = this.annaLokiparametrit(loki, kipienJaKayttajienNimetMap)
              const ending = loki.toiminto === LaskunToimintalokiTyyppi.TILASTO_UPDATE ? 'lemonator' : ''
              const viesti = this._lemonTranslationService.lokalisoi('lasku.tapahtumaloki.tyyppi' + loki.toiminto + ending, parametrit)
              lokit.push({
                loki: loki,
                parametrit: parametrit,
                tekija: (kipienJaKayttajienNimetMap.get(loki.emuloija_uid ?? loki.tekija_uid) || 'Tuntematon tekijä') + ' (' + (loki.emuloija_uid ?? loki.tekija_uid) + ')',
                viesti: viesti,
              })
              if (lokit.length === 1) {
                loki.toiminto = LaskunToimintalokiTyyppi.LUOTU
              }
            }
          }
        } else {
          const sallitutAvaimet = this._laskuSharedService.annaLaskuryppaanPaalaskunEriVersiot(this.juurilasku).map(versio => {
            return versio.avain
          })
          for (const loki of kaikkiLokit) {
            if (sallitutAvaimet.includes(loki.lasku_uid)) {
              const parametrit = this.annaLokiparametrit(loki, kipienJaKayttajienNimetMap)
              const ending = loki.toiminto === LaskunToimintalokiTyyppi.TILASTO_UPDATE ? 'lemonator' : ''
              const viesti = this._lemonTranslationService.lokalisoi('lasku.tapahtumaloki.tyyppi' + loki.toiminto + ending, parametrit)
              lokit.push({
                loki: loki,
                parametrit: parametrit,
                tekija: (kipienJaKayttajienNimetMap.get(loki.emuloija_uid ?? loki.tekija_uid) || 'Tuntematon tekijä') + ' (' + (loki.emuloija_uid ?? loki.tekija_uid) + ')',
                viesti: viesti,
              })
            }
          }
        }
        return lokit
      }),
      lemonShare(),
    )

    this.lokitietojaLadataanObservable = this.lokitiedotObservable.pipe(
      map(() => {
        return false
      }),
      startWith(true),
    )

    // Lataa reskontratiedot
    this.reskontraObservable = combineLatest([this._route.data, this._asiakasService.nykyinenAsiakasAvainObservable]).pipe(
      switchMap(([data, asiakas]: [{ data: LaskuKatseleComponentData }, AsiakkaanAvainTiedot]) => {
        if (data && data.data && data.data.juurilasku && data.data.juurilasku.avain && asiakas?.asiakasId) {
          return this._laskuService.getLaskuReskontraObservableAsiakkaalle(asiakas.avain, data.data.juurilasku.avain)
        } else {
          return of<LaskuReskontra[]>([])
        }
      }),
      lemonShare(),
    )

    this.reskontraSummaObservable = this.reskontraObservable.pipe(
      map(reskontra => {
        const maksettu = this._reskontraService.annaReskontranSumma(reskontra)
        if (this.juurilasku && this.juurilasku.tila === LaskunTila.maksettu) {
          return this._currencyService.muutaBigDecimalRahaksi(maksettu)
        } else if (this.kasiteltava) {
          return this._currencyService.muutaBigDecimalRahaksi(maksettu.minus(this.kasiteltava.summa))
        }
        return 0
      }),
    )

    this.reskontraaLadataanObservable = this.reskontraObservable.pipe(
      map(() => {
        return false
      }),
      startWith(true),
    )

    this.reskontraLokiObservable = combineLatest([this.reskontraObservable, this._lemonTranslationService.currentLanguageObservable, kipienJaKayttajienNimetMapObservable]).pipe(
      map(([reskontrat, kieli, kayttajienNimetMap]) => {
        return reskontrat
          .sort((a, b) => {
            return this._dateService.compareTimestamps(a.luotu, '<', b.luotu) ? -1 : 1
          })
          .map(r => {
            return { data: r, teksti: this._annaReskontraLokinSelite(r, this.kasiteltava?.valuutta, kayttajienNimetMap, kieli) }
          })
      }),
    )

    this.kirjanpitajaOnHallintoTaiLuottoObservable = this._kirjautunutKayttajaService.kirjanpitajaOnHallintoTaiLuottoObservable.pipe(
      map(oikeudet => oikeudet || environment.environment === EnvironmentType.BETA || environment.environment === EnvironmentType.DEV),
    )

    window.scroll({ top: 0, left: 0 })
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }

  valittajaDisplayFn(operaattori?: Verkkolaskuoperaattori): string | undefined {
    if (operaattori && operaattori.nimi) {
      return operaattori.nimi + ' (' + operaattori.tunnus + ')'
    }
    if (operaattori instanceof String || typeof operaattori === 'string') {
      return operaattori as any as string
    }
    return undefined
  }

  async lataaLiitetiedosto(liitetiedosto: LaskunLiitetiedosto) {
    this._ladataanService.aloitaLataaminen()
    const asiakas = await firstValueFrom(this._asiakasService.nykyinenAsiakasAvainObservable)
    if (!asiakas?.avain) {
      this._ladataanService.lopetaLataaminen()
      return
    }
    const liitetiedostoUri = this._laskuService.getLiitetiedostoUriAsiakkaalle(asiakas.avain, liitetiedosto)
    const url = '/laskuLataaLiite?a=' + encodeURIComponent('/api/1/laskut/lataaLiitetiedosto/' + liitetiedostoUri) + '&time=' + encodeURIComponent(new Date().getTime())
    return this._httpService
      .getBinary(url, LEMONATOR_CF_API)
      .then(result => {
        this._ladataanService.lopetaLataaminen()
        this._fileSaverService.saveAs(result, liitetiedosto.nimi)
      })
      .catch(err => {
        this._ladataanService.lopetaLataaminen()
        this._errorHandler.handleError(err)
      })
  }

  async lataaLasku() {
    const asiakas = await firstValueFrom(this._asiakasService.nykyinenAsiakasObservable)
    if (!asiakas?.avain) {
      return
    }
    if ((this.kasiteltava.print && this.kasiteltava.print.done) || (this.kasiteltava.email && this.kasiteltava.email.done) || (this.kasiteltava.sahkoinen && this.kasiteltava.sahkoinen.done)) {
      this._ladataanService.aloitaLataaminen()
      const pdfUri = this._laskuService.getPdfUrlAsiakkaalle(asiakas.asiakasId + '', this.kasiteltava)
      const url = '/api/1/laskut/lataaPdf/' + pdfUri
      return this._httpService
        .getBinary('/laskuLataaPdf?a=' + encodeURIComponent(url) + '&time=' + encodeURIComponent(new Date().getTime()), LEMONATOR_CF_API)
        .then(result => {
          const nimi = this._laskuService.annaPdfTiedostonNimiAsiakkaalle(asiakas, this.juurilasku, this.kasiteltava, this._lemonTranslationService.nykyinenKieli)
          this._ladataanService.lopetaLataaminen()
          this._fileSaverService.saveAs(result, nimi)
        })
        .catch(err => {
          this._ladataanService.lopetaLataaminen()
          this._errorHandler.handleError(err)
        })
    } else {
      const data: LaskuLataaDialogData = {
        juurilasku: this.juurilasku,
        kasiteltava: this.kasiteltava,
      }
      const dialogRef = this._dialog.open(LaskuLataaDialog, { data: data, panelClass: 'ilman-paddingia' })
    }
  }

  annaKorvatunOtsake(): string {
    const korvaava = this._laskuSharedService.annaKorvaavaLasku(this.juurilasku, this.kasiteltava)
    const korvaavanNumero =
      korvaava.nrotyyppi === LaskunumeroTyyppi.MUISTUTUS ? this._laskuSharedService.annaMuotoiltuLaskunumero(this.juurilasku, korvaava) : this._laskuSharedService.annaLaskunumero(korvaava)
    return `Laskusta on lähtenyt ${this._annaLaskutyypinNimi(korvaava.nrotyyppi)} ${korvaavanNumero}`.trim()
  }

  private _annaLaskutyypinNimi(nrotyyppi: LaskunumeroTyyppi): string {
    if (nrotyyppi === LaskunumeroTyyppi.MUISTUTUS) {
      return 'maksumuistutus'
    }
    if (nrotyyppi === LaskunumeroTyyppi.HYVITYS) {
      return 'hyvityslasku'
    }
    if (nrotyyppi === LaskunumeroTyyppi.KORJAUS) {
      return 'korjauslasku'
    }
    return 'uusi lasku'
  }

  naytaKorvatunOtsake(): boolean {
    return this._laskuSharedService.annaKorvaavaLasku(this.juurilasku, this.kasiteltava) && true
  }

  naytaTavallinenOtsake(): boolean {
    return !this.naytaKorvatunOtsake()
  }

  naytaSumma(): boolean {
    return !this.naytaKorvatunOtsake()
  }

  naytaMaksuaikaa(): boolean {
    return this.juurilasku && this.kasiteltava && (this.juurilasku.tila === LaskunTila.avoin || this.juurilasku.tila === LaskunTila.eraantynyt) && !this.naytaKorvatunOtsake()
  }

  annaMaksuaikaa(): number {
    if (this.kasiteltava && this.kasiteltava.erapvm) {
      return this._dateService.paiviaValissaTimestamp(this.kasiteltava.erapvm, this._timestampService.now())
    }
    return 0
  }

  // poistaLuonnos() {
  //   this.laskuService.poistaLuonnos(this.juurilasku, this.kasiteltava).then(() => {
  //     this.router.navigate(['/laskutus/laskut'])
  //   })
  // }

  async merkitseLuottotappioksi() {
    if (this._buttonPushInflight) {
      return
    }
    this._buttonPushInflight = true
    try {
      const kirjanpitaja = await firstValueFrom(this._kirjanpitajaService.kirjautuneenKayttajanKirjanpitajaObservable)
      await this._laskuService.merkitseLuottotappioksi(this.juurilasku, kirjanpitaja)
    } finally {
      this._buttonPushInflight = false
    }
  }

  async peruutaLuottotappiomerkinta() {
    if (this._buttonPushInflight) {
      return
    }
    this._buttonPushInflight = true
    try {
      const kirjanpitaja = await firstValueFrom(this._kirjanpitajaService.kirjautuneenKayttajanKirjanpitajaObservable)
      await this._laskuService.peruutaLuottotappiomerkinta(this.juurilasku, kirjanpitaja)
    } finally {
      this._buttonPushInflight = false
    }
  }

  async merkitseOsittainMaksetuksi() {
    if (this._buttonPushInflight) {
      return
    }
    this._buttonPushInflight = true
    try {
      const kirjanpitaja = await firstValueFrom(this._kirjanpitajaService.kirjautuneenKayttajanKirjanpitajaObservable)
      const reskontra = await firstValueFrom(this.reskontraObservable)
      const data: LaskuMerkitseOsittainMaksetuksiLemonatorDialogData = {
        juurilasku: this.juurilasku,
        kasiteltava: this.kasiteltava,
        reskontra: reskontra,
        kirjanpitaja: kirjanpitaja,
      }

      const settings: MatDialogConfig = {
        data: data,
        panelClass: 'ilman-paddingia',
        // ,
        // maxWidth: '1600px',
        // maxHeight: korkeus,
        // width: leveys
      }
      const dialogRef = this._dialog.open(LaskuMerkitseOsittainMaksetuksiLemonatorDialog, settings)
    } finally {
      this._buttonPushInflight = false
    }
  }

  // muokkaa() {

  //   // console.log(this.juurilasku.tila, this.juurilasku.tila === LaskunTila.luonnos)

  //   if (this.kasiteltava.print && this.kasiteltava.print.start) {

  //     const data: LaskuMuokkaaTulostettuaDialogData = {
  //       juurilasku: this.juurilasku,
  //       kasiteltava: this.kasiteltava,
  //       asetukset: this.asetukset
  //     }
  //     const settings: MatDialogConfig = {
  //       data: data
  //     }
  //     this.dialog.open(LaskuMuokkaaTulostettuaDialog, settings)

  //   } else {

  //     const data: LaskuComponentExistingData = {
  //       juurilasku: this.juurilasku,
  //       asetukset: this.asetukset
  //     }
  //     this.laskuComponentDataResolve.asetaOlemassaolevaData(data)

  //     if (this.juurilasku.tila === LaskunTila.luonnos) {
  //       this.router.navigate(['/laskutus/laskut/', this.juurilasku.avain, this.kasiteltava.avain])
  //     } else {
  //       this.router.navigate(['/laskutus/laskut/', this.juurilasku.avain, UUDEN_LASKUN_AVAIN])
  //     }

  //   }

  // }

  onkoLataaLaskuNakyvissa(): boolean {
    return this.kasiteltava && (!!this.kasiteltava.print?.done || !!this.kasiteltava.email?.done || !!this.kasiteltava.sahkoinen?.done)
  }

  // onkoPoistoLuonnosNakyvissa(): boolean {
  //   return this.kasiteltava &&
  //     this.juurilasku.tila === LaskunTila.luonnos
  // }

  onkoHyvitaNakyvissa(): boolean {
    return (
      this.kasiteltava &&
      this.kasiteltava.nrotyyppi !== LaskunumeroTyyppi.HYVITYS &&
      (this.juurilasku.tila === LaskunTila.avoin ||
        this.juurilasku.tila === LaskunTila.maksettuLiikaa ||
        this.juurilasku.tila === LaskunTila.maksettu ||
        this.juurilasku.tila === LaskunTila.eraantynyt)
    )
  }

  onkoPeruutaLuottotappioMerkintaNakyvissa(): boolean {
    return this.kasiteltava && this.juurilasku.tila === LaskunTila.luottotappio
  }

  onkoMerkitseOsittainMaksetuksiNakyvissa(): boolean {
    return (
      this.kasiteltava &&
      this.kasiteltava.nrotyyppi !== LaskunumeroTyyppi.HYVITYS &&
      this.juurilasku.tila !== LaskunTila.luottotappio &&
      this._laskuSharedService.onkoKasiteltavaMuuKuinLuonnos(this.juurilasku, this.kasiteltava)
    )
  }

  onkoMerkitseLuottotappioksiNakyvissa(): boolean {
    return (
      this.kasiteltava &&
      this.kasiteltava.nrotyyppi !== LaskunumeroTyyppi.HYVITYS &&
      this.juurilasku.tila !== LaskunTila.luottotappio &&
      this.juurilasku.tila !== LaskunTila.maksettu &&
      this.juurilasku.tila !== LaskunTila.maksettuLiikaa &&
      this._laskuSharedService.onkoKasiteltavaMuuKuinLuonnos(this.juurilasku, this.kasiteltava)
    )
  }

  onkoMaksumuistutusNakyvissa(): boolean {
    return (
      this.kasiteltava &&
      this.kasiteltava.nrotyyppi !== LaskunumeroTyyppi.HYVITYS &&
      this.juurilasku.tila !== LaskunTila.luottotappio &&
      this.juurilasku.tila !== LaskunTila.maksettu &&
      this.juurilasku.tila !== LaskunTila.maksettuLiikaa &&
      this._laskuSharedService.onkoKasiteltavaMuuKuinLuonnos(this.juurilasku, this.kasiteltava)
    )
  }

  onkoPurkuunLiittyvatNakyvissa(): boolean {
    return this.kasiteltava && this.kasiteltava.nrotyyppi !== LaskunumeroTyyppi.HYVITYS && this.juurilasku.tila === LaskunTila.eraantynyt
  }

  hyvita() {
    if (this._buttonPushInflight) {
      return
    }
    this._buttonPushInflight = true
    try {
      // Vaihda jatkuvan laskutuksen tuotteet korjaustuotteiksi
      const muokattuJuurilasku = this._laskuKopioija.copyLasku(this.juurilasku)
      this._laskuKopioija.korvaaJatkuvatTuotteetKorjaustuotteilla(muokattuJuurilasku)

      const data: LaskuComponentExistingData = {
        juurilasku: muokattuJuurilasku,
        asetukset: this.asetukset,
      }
      this._laskuComponentDataResolve.asetaOlemassaolevaData(data)

      this._router.navigate(['asiakkaat', this.asiakas.avain, 'laskutus', 'luo', this.juurilasku.avain, 'hyvita']).then(result => {
        this._vasenValikkoService.paivitaAuki(true)
      })
    } finally {
      this._buttonPushInflight = false
    }
  }

  async lahetaMuistutuslasku() {
    if (this._buttonPushInflight) {
      return
    }
    this._buttonPushInflight = true

    // this._ladataanService.aloitaLataaminen()
    try {
      const muokattavaksiJuuri = this._laskuKopioija.copyLasku(this.juurilasku)
      this._laskuKopioija.korvaaJatkuvatTuotteetKorjaustuotteilla(muokattavaksiJuuri)
      const viimeisinTavallinen = this._laskuSharedService.annaViimeisinTavallinenLasku(muokattavaksiJuuri)
      const [asiakas, reskontra] = await Promise.all([this._laskuService.haeAsiakas(viimeisinTavallinen), firstValueFrom(this.reskontraObservable)])
      const laskunAsiakas = this._laskuService.lemonatorAsiakasLaskunAsiakkaaksi(asiakas)

      const laskunTyyppi = LaskunTyypit.annaLaskunTyyppi(viimeisinTavallinen.tyyppi)
      if (!laskunTyyppi) {
        throw new Error('Ei LaskunTyyppiä avaimella: ' + viimeisinTavallinen.tyyppi)
      }

      const alvt = await this._alvService.annaLaskutyypinAlvt(laskunTyyppi, asiakas.maa)
      if (!alvt?.length) {
        throw new Error('Ei ALV-määrityksiä tyypille ' + laskunTyyppi + ' ja maalle ' + asiakas.maa)
      }

      const muokattavaksiKasiteltava = this._laskuKopioija.kopioiLaskuMuistutusLaskuksi(muokattavaksiJuuri, viimeisinTavallinen, laskunAsiakas, alvt)
      muokattavaksiKasiteltava.kopioitu.asetukset = await firstValueFrom(this._laskuService.asetuksetObservable.pipe(first(asetukset => !!asetukset)))
      this._laskuSharedService.lisaaLiittyviinLaskuihinIlmanMuutostenKeraamista(muokattavaksiJuuri, muokattavaksiKasiteltava.kopioitu)

      const data: LaskunLahetysdata = {
        juurilasku: muokattavaksiJuuri,
        asetukset: muokattavaksiKasiteltava.kopioitu.asetukset,
        kasiteltava: muokattavaksiKasiteltava.kopioitu,
        reskontra: reskontra,
        huomautuskulu: muokattavaksiKasiteltava.huomautuskulu,
        korkokulu: muokattavaksiKasiteltava.korkokulu,
        muistutus: true,
      }
      this.lahetysdata.next(data)

      if (this.kasiteltava.asiakas.viimeisinLaskuLahetetty) {
        switch (this.kasiteltava.asiakas.viimeisinLaskuLahetetty) {
          case LaskunLahetystapa.SAHKOPOSTI:
            this.aktiivinenValilehti.next(0)
            break
          case LaskunLahetystapa.SAHKOINEN:
            this.aktiivinenValilehti.next(1)
            break
          case LaskunLahetystapa.ITSE:
            this.aktiivinenValilehti.next(2)
            break
          case LaskunLahetystapa.PAPERI:
            this.aktiivinenValilehti.next(3)
            break
          default:
            this.aktiivinenValilehti.next(0)
        }
      } else {
        this.aktiivinenValilehti.next(0)
      }

      setTimeout(() => {
        this._vasenValikkoService.paivitaAuki(false)
      }, 25)

      setTimeout(() => {
        const scrollable = document.querySelector('[cdk-scrollable]')
        if (scrollable) {
          scrollable.scrollTop = 0
        } else {
          window.scrollTo(0, 0)
        }
      }, 50)
    } catch (error) {
      this._errorHandler.handleError(error)
    } finally {
      // this._ladataanService.lopetaLataaminen()
      this._buttonPushInflight = false
    }
  }

  async lahetaUudelleen() {
    if (this._buttonPushInflight) {
      return
    }
    this._buttonPushInflight = true
    this._ladataanService.aloitaLataaminen()
    try {
      const kirjanpitaja = await firstValueFrom(this._kirjanpitajaService.kirjautuneenKayttajanKirjanpitajaObservable)
      await this._laskuService.lahetaLaskuUudelleen(this.juurilasku, this.kasiteltava, kirjanpitaja)
    } catch (error) {
      this._errorHandler.handleError(error)
    } finally {
      this._ladataanService.lopetaLataaminen()
      this._buttonPushInflight = false
    }
  }

  async lahetaUudelleenEriTavalla() {
    if (this._buttonPushInflight) {
      return
    }
    this._buttonPushInflight = true
    this._ladataanService.aloitaLataaminen()
    try {
      const reskontra = await firstValueFrom(this.reskontraObservable)

      const data: LaskunLahetysdata = {
        juurilasku: this.juurilasku,
        asetukset: this.asetukset,
        kasiteltava: this.kasiteltava,
        reskontra: reskontra,
        huomautuskulu: null,
        korkokulu: null,
        muistutus: this.kasiteltava.nrotyyppi === LaskunumeroTyyppi.MUISTUTUS,
        uudelleenlahetys: true,
      }
      this.lahetysdata.next(data)

      if (this.kasiteltava.email?.done) {
        this.aktiivinenValilehti.next(0)
      } else if (this.kasiteltava.sahkoinen?.done) {
        this.aktiivinenValilehti.next(1)
      } else if (this.kasiteltava.print?.done) {
        this.aktiivinenValilehti.next(2)
      } else {
        this.aktiivinenValilehti.next(0)
      }

      setTimeout(() => {
        this._vasenValikkoService.paivitaAuki(false)
      }, 25)

      setTimeout(() => {
        const scrollable = document.querySelector('[cdk-scrollable]')
        if (scrollable) {
          scrollable.scrollTop = 0
        } else {
          window.scrollTo(0, 0)
        }
      }, 50)
    } catch (error) {
      this._errorHandler.handleError(error)
    } finally {
      this._ladataanService.lopetaLataaminen()
      this._buttonPushInflight = false
    }
  }

  async lahetaHyvityslaskuUudelleenSahkopostiin() {
    if (this._buttonPushInflight) {
      return
    }
    this._buttonPushInflight = true

    this._ladataanService.aloitaLataaminen()
    try {
      const [asiakas, reskontra] = await Promise.all([this._laskuService.haeAsiakas(this.kasiteltava), firstValueFrom(this.reskontraObservable)])

      const laskunTyyppi = LaskunTyypit.annaLaskunTyyppi(this.kasiteltava.tyyppi)
      if (!laskunTyyppi) {
        throw new Error('Ei LaskunTyyppiä avaimella: ' + this.kasiteltava.tyyppi)
      }

      const alvt = await this._alvService.annaLaskutyypinAlvt(laskunTyyppi, asiakas.maa)
      if (!alvt?.length) {
        throw new Error('Ei ALV-määrityksiä tyypille ' + laskunTyyppi + ' ja maalle ' + asiakas.maa)
      }

      const data: LaskunLahetysdata = {
        juurilasku: this.juurilasku,
        asetukset: this.asetukset,
        kasiteltava: this.kasiteltava,
        reskontra: reskontra,
        huomautuskulu: null,
        korkokulu: null,
        muistutus: false,
      }
      this.lahetysdata.next(data)
      this.aktiivinenValilehti.next(0)

      setTimeout(() => {
        this._vasenValikkoService.paivitaAuki(false)
      }, 25)

      setTimeout(() => {
        const scrollable = document.querySelector('[cdk-scrollable]')
        if (scrollable) {
          scrollable.scrollTop = 0
        } else {
          window.scrollTo(0, 0)
        }
      }, 50)
    } catch (error) {
      this._errorHandler.handleError(error)
    } finally {
      this._ladataanService.lopetaLataaminen()
      this._buttonPushInflight = false
    }
  }

  async lahetaPerintaritarimuistutuslaskuHallinto() {
    if (this._buttonPushInflight) {
      return
    }
    this._buttonPushInflight = true

    this._ladataanService.aloitaLataaminen()
    try {
      const muokattavaksiJuuri = this._laskuKopioija.copyLasku(this.juurilasku)
      this._laskuKopioija.korvaaJatkuvatTuotteetKorjaustuotteilla(muokattavaksiJuuri)
      const viimeisinTavallinen = this._laskuSharedService.annaViimeisinTavallinenLasku(muokattavaksiJuuri)
      const asiakas = await this._laskuService.haeAsiakas(viimeisinTavallinen)
      const laskunAsiakas = this._laskuService.lemonatorAsiakasLaskunAsiakkaaksi(asiakas)

      if (!asiakas) {
        throw new Error('Asiakkaan haku epäonnistui')
      }

      const laskunTyyppi = LaskunTyypit.annaLaskunTyyppi(viimeisinTavallinen.tyyppi)
      if (!laskunTyyppi) {
        throw new Error('Ei LaskunTyyppiä avaimella: ' + viimeisinTavallinen.tyyppi)
      }

      const alvt = await this._alvService.annaLaskutyypinAlvt(laskunTyyppi, asiakas.maa)
      if (!alvt?.length) {
        throw new Error('Ei ALV-määrityksiä tyypille ' + laskunTyyppi + ' ja maalle ' + asiakas.maa)
      }

      const muokattavaksiKasiteltava = this._laskuKopioija.kopioiLaskuMuistutusLaskuksi(muokattavaksiJuuri, viimeisinTavallinen, laskunAsiakas, alvt)

      // Perintäritarin lähetykseen lisätään tilastotiedot hiljaisesti, koska lähetys tapahtuu suoraan napin painalluksesta
      await this._laskuService.asetaLaskunTilastoksiKirjautunutkirjanpitaja(muokattavaksiKasiteltava.kopioitu)

      muokattavaksiKasiteltava.kopioitu.asetukset = await firstValueFrom(this._laskuService.asetuksetObservable.pipe(first(asetukset => !!asetukset)))
      this._laskuSharedService.lisaaLiittyviinLaskuihinIlmanMuutostenKeraamista(muokattavaksiJuuri, muokattavaksiKasiteltava.kopioitu)

      this._ladataanService.aloitaLataaminen()
      const vastaanottajat: EmailLahetysStatus[] = [
        {
          email: 'lemontree@perintaritari.com',
          status: EmailLahetysStatusKoodi.PROSESSOIDAAN,
          viesti: null,
        },
      ]

      const spostiasetukset = this._laskuSpostiService.annaSpostiAsetukset(muokattavaksiKasiteltava.kopioitu, true, muokattavaksiKasiteltava.kopioitu.asetukset)

      const postmarkTemplateId = this._laskuSpostiService.annaSahkopostipohjanPostmarkNumero(spostiasetukset.template, muokattavaksiKasiteltava.kopioitu.kieli)
      const aihe = spostiasetukset.aihe
      const otsikko = spostiasetukset.otsikko
      const teksti = spostiasetukset.teksti

      const kirjanpitaja = await firstValueFrom(this._kirjanpitajaService.kirjautuneenKayttajanKirjanpitajaObservable)
      await this._laskuService.merkitseLaskunMaksumuistutusLahetetyksiSpostilla(
        asiakas,
        kirjanpitaja,
        postmarkTemplateId,
        muokattavaksiJuuri,
        muokattavaksiKasiteltava.kopioitu,
        vastaanottajat,
        aihe,
        otsikko,
        teksti,
        this.asetukset.slogan,
        false,
      )
    } catch (error) {
      this._errorHandler.handleError(error)
    } finally {
      this._ladataanService.lopetaLataaminen()
      this._buttonPushInflight = false
    }
  }

  protected _naytaNappulat(): boolean {
    if (!this.kasiteltava) {
      return false
    }
    if (!this.kasiteltava.avain) {
      return false
    }
    if (this.kasiteltava.nrotyyppi !== LaskunumeroTyyppi.MUISTUTUS) {
      return this._laskuSharedService.onkoKasiteltavaMuuKuinMitatoity(this.juurilasku, this.kasiteltava)
    }
    return false
  }

  private naytaMuokkausnappulat(): boolean {
    if (!this.kasiteltava) {
      return false
    }
    if (!this.kasiteltava.avain) {
      return false
    }
    const liittyvatLaskut = this._laskuSharedService.annaLiittyvatLaskut(this.juurilasku)
    if (!liittyvatLaskut.length) {
      return this._laskuSharedService.onkoKasiteltavaMuuKuinMitatoity(this.juurilasku, this.kasiteltava)
    }
    if (liittyvatLaskut[liittyvatLaskut.length - 1].avain === this.kasiteltava.avain) {
      return this._laskuSharedService.onkoKasiteltavaMuuKuinMitatoity(this.juurilasku, this.kasiteltava)
    }
    return false
  }

  naytaEpaonnistunutSahkoinen(): boolean {
    if (!this.kasiteltava || !this.kasiteltava.sahkoinen) {
      return false
    }

    if (this.kasiteltava.sahkoinen.status !== LaskuSahkoinenLahetysStatusKoodi.LAHETETTY_VASTAANOTTAJALLE && this.kasiteltava.sahkoinen.status !== LaskuSahkoinenLahetysStatusKoodi.PROSESSOIDAAN) {
      return true
    }

    return false
  }

  naytaEpaonnistunutSposti(): boolean {
    if (!this.naytaMuokkausnappulat()) {
      return false
    }

    if (!this.kasiteltava || !this.kasiteltava.email || !this.kasiteltava.email.vastaanottajat) {
      return false
    }

    for (const vastaanottaja of this.kasiteltava.email.vastaanottajat) {
      if (vastaanottaja.status === EmailLahetysStatusKoodi.LAHETYS_EPAONNISTUI) {
        return true
      }
    }

    return false
  }

  naytaKokoVirhe(vastaanottaja: EmailLahetysStatus) {
    const dialogRef = this._dialog.open(LaskuKokoVirheDialog, { data: vastaanottaja, panelClass: 'ilman-paddingia' })
  }

  async lahetaEmailUudelleen(vastaanottaja: KorjattavaEmailLahetysStatus) {
    if (this._buttonPushInflight) {
      return
    }
    this._buttonPushInflight = true
    this._ladataanService.aloitaLataaminen()
    try {
      const kirjanpitaja = await firstValueFrom(this._kirjanpitajaService.kirjautuneenKayttajanKirjanpitajaObservable)
      const asiakas = await this._laskuService.haeAsiakas(this.kasiteltava)

      if (kirjanpitaja && asiakas) {
        await this._laskuService.lahetaEmailUudelleen(this.juurilasku, this.kasiteltava, asiakas, kirjanpitaja, vastaanottaja, vastaanottaja.vanhaEmail)
      }
    } catch (error) {
      this._errorHandler.handleError(error)
    } finally {
      this._ladataanService.lopetaLataaminen()
      this._buttonPushInflight = false
    }
  }

  async lahetaSahkoinenUudelleen() {
    if (!this.sahkoinenLomake().valid()) {
      this._validationService.merkitseKokoLomakeKosketuksi(this.sahkoinenLomake)
      return
    }
    if (this._buttonPushInflight) {
      return
    }
    this._buttonPushInflight = true
    this._ladataanService.aloitaLataaminen()
    try {
      const kirjanpitaja = await firstValueFrom(this._kirjanpitajaService.kirjautuneenKayttajanKirjanpitajaObservable)
      const asiakas = await this._laskuService.haeAsiakas(this.kasiteltava)

      if (kirjanpitaja && asiakas) {
        await this._laskuService.lahetaSahkoinenUudelleen(this.juurilasku, this.kasiteltava, asiakas, kirjanpitaja)
      }
    } catch (error) {
      this._errorHandler.handleError(error)
    } finally {
      this._ladataanService.lopetaLataaminen()
      this._buttonPushInflight = false
    }
  }

  private annaLokiparametrit(loki: LaskuToimintaloki, kipienJaKayttajienNimetMap: Map<string, string>) {
    const paluuarvo: any = {}

    paluuarvo.lasku_nro = this._laskuSharedService.annaMuotoiltuLaskunumero(this.juurilasku, this.kasiteltava)

    if (loki.toiminto === LaskunToimintalokiTyyppi.LAHETETTY_SPOSTI || loki.toiminto === LaskunToimintalokiTyyppi.LAHETETTY_MAKSUMUISTUTUS_SPOSTI) {
      if (loki.parametrit) {
        const parametrit = loki.parametrit as LaskunToimintalokiSpostiParametrit
        paluuarvo.osoitteet = parametrit.emailit ? parametrit.emailit.join(', ') : ''
      } else {
        paluuarvo.osoitteet = '?'
      }
    } else if (
      loki.toiminto === LaskunToimintalokiTyyppi.LAHETETTY_SAHKOINEN ||
      loki.toiminto === LaskunToimintalokiTyyppi.LAHETETTY_TULOSTA_TOISEN_HYVAKSYNTAJONOON_ODOTTAMAAN_HYVAKSYNTAA ||
      loki.toiminto === LaskunToimintalokiTyyppi.LAHETETTY_SAHKOISESTI_TOISEN_HYVAKSYNTAJONOSTA_HYVAKSYNNAN_JALKEEN
    ) {
      if (loki.parametrit) {
        const parametrit = loki.parametrit as LaskunToimintalokiSahkoinenParametrit
        const tunnus = parametrit.osoite && parametrit.osoite.sahkoinenValittaja ? parametrit.osoite.sahkoinenValittaja : ''
        const kaytettevaTunnus = (tunnus as any).tunnus ? (tunnus as any).tunnus : tunnus
        // console.log(kaytettevaTunnus)
        const nimi = this._sahkoisenLaskunValittajaService.annaValittajanNimi(kaytettevaTunnus)
        const valittaja = kaytettevaTunnus + (nimi ? ' (' + nimi + ')' : '')
        // console.log(valittaja)
        paluuarvo.sahkoinenOsoite = parametrit.osoite && parametrit.osoite.sahkoinenOsoite ? parametrit.osoite.sahkoinenOsoite : ''
        paluuarvo.sahkoinenValittaja = valittaja
      } else {
        paluuarvo.sahkoinenOsoite = '?'
        paluuarvo.sahkoinenValittaja = '?'
      }
    } else if (loki.toiminto === LaskunToimintalokiTyyppi.TILASTO_UPDATE) {
      if (loki.parametrit) {
        const parametrit = loki.parametrit as LaskunToimintalokiTilastoParametrit
        paluuarvo.vanhaTiimi = parametrit.vanhaTiimi ?? '?'
        paluuarvo.uusiTiimi = parametrit.uusiTiimi ?? '?'
        paluuarvo.vanhaKirjanpitaja = (kipienJaKayttajienNimetMap.get(parametrit.vanhaKirjanpitaja) ?? '?') + ' (' + (parametrit.vanhaKirjanpitaja ?? '?') + ')'
        paluuarvo.uusiKirjanpitaja = (kipienJaKayttajienNimetMap.get(parametrit.uusiKirjanpitaja) ?? '?') + ' (' + (parametrit.uusiKirjanpitaja ?? '?') + ')'
      } else {
        paluuarvo.vanhaTiimi = '?'
        paluuarvo.uusiTiimi = '?'
        paluuarvo.vanhaKirjanpitaja = '?'
        paluuarvo.uusiKirjanpitaja = '?'
      }
    }

    return paluuarvo
  }

  onkoVirhe<T>(kentta: FieldTree<T>, laji: string): boolean {
    return kentta()
      .errors()
      .some(virhe => virhe.kind === laji)
  }

  naytaLoki(loki: KasiteltyLokitieto) {
    this._dialog.open(LaskuReskontraTiedotDialog, { data: loki })
  }

  naytaMerkinta(merkinta: LaskuReskontra) {
    this._dialog.open(LaskuReskontraTiedotDialog, { data: merkinta })
  }

  // peruuta() {
  //   this.router.navigate(['asiakkaat', '/laskutus/laskut'])
  // }

  vertaaYhtaSuuret(yksi: number, kaksi: number): boolean {
    return this._currencyService.roundHalfUp(yksi, 2) === this._currencyService.roundHalfUp(kaksi, 2)
  }

  vertaaEkaPienempiKuinToka(pienempi: number, suurempi: number): boolean {
    return this._currencyService.roundHalfUp(pienempi, 2) < this._currencyService.roundHalfUp(suurempi, 2)
  }

  async lahetaPurkuViesti(tyyppi: ViestiTyyppi) {
    const dialogData: AreYouSureDialogData = {
      rightAction: 'Lähetä',
      header: 'Lähetä viesti',
      text:
        'Haluatko varmasti lähettää ' +
        (tyyppi === 'purku_maksamattomat' ? 'purku' : 'purku-uhka') +
        ' viestin? Asiakkaalla tulee olla vähintään 1 erääntynyt lasku, jotta viesti voidaan lähettää. Viesti lähetetään asiakkaan ' +
        this.data.juurilasku.asiakas.nimi +
        ' aktiiviselle sopimuksen hyväksyjälle, sekä piilokopiona kirjanpitäjälle ja tiiminvetäjälle.',
    }

    const tallentavaKirjanpitaja = await firstValueFrom(this._kirjanpitajaService.kirjautuneenKayttajanKirjanpitajaObservable)

    const yes = await firstValueFrom(this._dialog.open(AreYouSureDialog, { data: dialogData }).afterClosed())
    if (yes) {
      try {
        if (this._buttonPushInflight) {
          return
        }
        this._ladataanService.aloitaLataaminen()
        this._buttonPushInflight = true

        await this._laskuService.merkitsePurkuViestiLahetetyksi(this.data.juurilasku.asiakas, this.data.juurilasku.avain, tyyppi, tallentavaKirjanpitaja)
        this._snackbar.open('Viestin lähetys onnistui.', 'OK', { duration: 5000 })
      } catch (error) {
        this._errorHandler.handleError(error)
        this._snackbar.open(this._lemonTranslationService.lokalisoi('yleiset.tuntematon-virhe'), 'OK', { duration: 5000 })
      } finally {
        this._ladataanService.lopetaLataaminen()
        this._buttonPushInflight = false
      }
    }
  }

  async laskeReskontraUudelleen() {
    if (this._buttonPushInflight) {
      return
    }

    this._buttonPushInflight = true
    this._ladataanService.aloitaLataaminen()

    const asiakas = await firstValueFrom(this._asiakasService.nykyinenAsiakasAvainObservable)
    if (!asiakas) {
      this._ladataanService.lopetaLataaminen()
      this._buttonPushInflight = false
      return
    }

    try {
      const req: LaskuKaynnistaOperaatioRequest = {
        asiakasAvain: asiakas.avain,
        asiakasId: asiakas.asiakasId,
        juurilaskuAvain: this.juurilasku.avain,
        kasiteltavaAvain: this.kasiteltava.avain,
        operation: 'laske-reskontra-tila-ja-indeksoi-uudelleen',
      }
      await this._firebaseLemonator.functionsCall<LaskuKaynnistaOperaatioRequest, LaskuKaynnistaOperaatioResponse>('laskuoperaatiot', req)
    } catch (error) {
      this._errorHandler.handleError(error)
    } finally {
      this._ladataanService.lopetaLataaminen()
      this._buttonPushInflight = false
    }
  }

  navigoiAsiakkaaseen() {
    if (this.kasiteltava?.asiakas?.avain) {
      const url = this._router.serializeUrl(this._router.createUrlTree(['asiakkaat', this.kasiteltava.asiakas.avain, 'asiakastiedot']))
      window.open(url, '_blank')
    }
  }

  private _annaReskontraLokinSelite(reskontra: LaskuReskontra, valutta: string, kayttajienNimetMap: Map<string, string>, kieli: TuettuKieli): string {
    const kayttajanNimi = reskontra.tekijaUid === 'lemonator_system' ? 'lemonator_system' : (kayttajienNimetMap.get(reskontra.tekijaUid) ?? 'Tuntematon käyttäjä') + '(' + reskontra.tekijaUid + ')'
    if (reskontra.siirrettyTilitapahtumasta) {
      const maksajaPart = reskontra.maksaja ? ' (' + reskontra.maksaja + ')' : ''
      return `${this._dateService.muotoile(reskontra.luotu.toDate(), 'dd.MM.yyyy HH:mm:ss')}, ${kayttajanNimi}: ${this._lemonTranslationService.lokalisoi('lasku.katsele-muokattava-dialog.automaattimerkinta-tilitapahtumasta')}: ${this._currencyService.formatoiRaha(reskontra.suoritus, valutta.toLowerCase(), kieli)}${maksajaPart}`
    }
    if (reskontra.siirrettyLaskuun) {
      return `${this._dateService.muotoile(reskontra.luotu.toDate(), 'dd.MM.yyyy HH:mm:ss')}, ${kayttajanNimi}: Siirretty laskuun nro ${reskontra.siirrettyLaskuunNro}: ${this._currencyService.formatoiRaha(reskontra.suoritus, valutta.toLowerCase(), kieli)}`
    }
    if (reskontra.siirrettyLaskusta) {
      return `${this._dateService.muotoile(reskontra.luotu.toDate(), 'dd.MM.yyyy HH:mm:ss')}, ${kayttajanNimi}: Siirretty laskusta nro ${reskontra.siirrettyLaskustaNro}: ${this._currencyService.formatoiRaha(reskontra.suoritus, valutta.toLowerCase(), kieli)}`
    }
    return `${this._dateService.muotoile(reskontra.luotu.toDate(), 'dd.MM.yyyy HH:mm:ss')}, ${kayttajanNimi}: ${this._currencyService.formatoiRaha(reskontra.suoritus, valutta.toLowerCase(), kieli)}`
  }

  vaihdaValilehti(indeksi: number) {
    this.aktiivinenValilehti.next(indeksi)
  }

  peruutaLahettaminen() {
    this.lahetysdata.next(null)
    setTimeout(() => {
      this._vasenValikkoService.paivitaAuki(true)
    }, 25)
  }

  peruuta() {
    this._router.navigate(['/laskutus/laskut'])
  }

  private _annaMaksuaikaa(kasiteltava: LaskuBase): number {
    if (kasiteltava?.erapvm) {
      return this._dateService.paiviaValissaTimestamp(kasiteltava.erapvm, this._timestampService.now())
    }
    return 0
  }

  private _vertaaYhtaSuuret(yksi: number, kaksi: number): boolean {
    return this._currencyService.roundHalfUp(yksi, 2) === this._currencyService.roundHalfUp(kaksi, 2)
  }

  private _vertaaEkaPienempiKuinToka(pienempi: number, suurempi: number): boolean {
    return this._currencyService.roundHalfUp(pienempi, 2) < this._currencyService.roundHalfUp(suurempi, 2)
  }

  private _annaSummatekstinVari(juurilasku: Lasku, kasiteltava: LaskuBase): SummatekstinVari {
    if (juurilasku.tila === LaskunTila.eraantynyt) {
      return 'red'
    } else if (juurilasku.tila === LaskunTila.maksettuLiikaa) {
      return 'purple'
    } else if (juurilasku.tila === LaskunTila.maksettu) {
      return 'green'
    } else if (juurilasku.tila === LaskunTila.avoin) {
      if (this._vertaaEkaPienempiKuinToka(kasiteltava.avoinna, kasiteltava.summa) && this._vertaaEkaPienempiKuinToka(0, kasiteltava.avoinna)) {
        return 'yellow'
      } else if (this._vertaaYhtaSuuret(kasiteltava.avoinna, kasiteltava.summa)) {
        return 'blue'
      }
    }

    return null
  }

  async kasitteleLahetys(event: LaskunLahetystiedot) {
    if (!event.error && event.tapa) {
      const olemassaoleva: LaskuKatseleComponentExistingData = {
        juurilasku: event.lahetettyJuuri,
        kasiteltava: event.lahetettyKasiteltava,
      }
      if (!this.asiakas?.avain) {
        return
      }
      this._laskuSelaaKatseleComponentDataResolve.asetaOlemassaolevaData(olemassaoleva)
      this.lahetysdata.next(null)
      if (event.tapa === LaskunLahetystapa.ITSE) {
        this._router.navigate(['asiakkaat', this.asiakas.avain, 'laskut', 'selaa', event.lahetettyJuuri.avain, event.lahetettyKasiteltava.avain, 'tulosta'])
      } else {
        this._router.navigate(['asiakkaat', this.asiakas.avain, 'laskut', 'selaa', event.lahetettyJuuri.avain, event.lahetettyKasiteltava.avain, 'katsele'])
      }
    } else {
      if (event.error) {
        this._ladataanService.naytaVirheDialog(event.error)
      }
    }
    setTimeout(() => {
      this._vasenValikkoService.paivitaAuki(true)
    }, 25)
  }
}
